import React, { useState, useEffect } from 'react';
import { FaFilePdf, FaExternalLinkAlt, FaAward } from 'react-icons/fa';
import './rdso.css';
import { rdsoService } from '../../services/rdsoService';
import { getMediaUrl } from '../../services/api';

/*
const PDF_DOCUMENTS = [
  {
    id: 'skv_rdso_approved_2025',
    filename: 'SKV RDSO APPROVED 2025.pdf',
    title: 'Ministry of Railways RDSO Final Approval (2025)',
    category: 'RDSO Approval',
    pageCount: 2,
    pageBadge: '01 / 02',
    thumbnail: 'assets/PDF_previews/skv_rdso_approved_2025_p1.jpg',
    description: 'Government of India, Ministry of Railways RDSO Final Decision Approval for Steel Plate Girders.'
  }
];
*/

const RdsoCertification = () => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    rdsoService.getRdsoContent()
      .then(res => {
        if (res.success && Array.isArray(res.data)) {
          setSections(res.data);
        }
      })
      .catch(err => {
        console.error('Failed to load RDSO content from database:', err);
      });
  }, []);

  return (
    <section className="rdso-page-sec">
      <div className="container">
        
        {/* Section Header */}
        <div className="row">
          <div className="col-12 text-center text-md-start">
            <div className="rdso-header-intro">
              <span className="rdso-section-tag">Quality Assurance & Approvals</span>
              <h1 className="rdso-main-title">RDSO CERTIFICATION</h1>
              <div className="rdso-title-separator"></div>
              {/* <p className="rdso-intro-text">
                SKV Industriees is approved by the Research Designs & Standards Organisation (RDSO), Ministry of Railways, 
                Government of India, for the fabrication of Welded Steel Bridge Girders. Explore our latest official approval letters, 
                ISO & BIS certifications, testing laboratory qualifications, plant infrastructure records, and completed & ongoing railway projects.
              </p> */}
            </div>
          </div>
        </div>

        {/* Section 1: First-Page PDF Showcase Grid */}
        {/* <div className="rdso-cards-grid">
          {PDF_DOCUMENTS.map((doc) => {
            const pdfHref = getDocPath(doc.filename);
            const thumbHref = getPreviewPath(doc.thumbnail);
            return (
              <div key={doc.id} className="rdso-pdf-card">
                <div className="rdso-pdf-thumb-wrapper">
                  <img
                    src={thumbHref}
                    alt={doc.title}
                    className="rdso-pdf-thumb-img"
                    loading="lazy"
                  />
                  
                  <div className="rdso-card-page-badge">
                    <span>Page {doc.pageBadge}</span>
                  </div>

                  <div className="rdso-pdf-thumb-overlay">
                    <a
                      href={pdfHref}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rdso-overlay-btn"
                    >
                      <FaExternalLinkAlt /> Open in New Tab
                    </a>
                  </div>
                </div>

                <div className="rdso-card-body">
                  <div>
                    <span className="rdso-card-category">{doc.category}</span>
                    <h3 className="rdso-card-title">{doc.title}</h3>
                  </div>

                  <div className="rdso-card-footer">
                    <span className="rdso-pdf-icon-indicator" title="PDF Document">
                      <FaFilePdf />
                    </span>
                    <a
                      href={pdfHref}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rdso-open-link"
                    >
                      <span>View PDF</span>
                      <FaExternalLinkAlt />
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div> */}

        {/* Section 2: RDSO CERTIFICATION Table */}
        <div className="row">
          <div className="col-12">
            <div className="rdso-table-card">
              <div className="rdso-table-header-box">
                <div>
                  <h2 className="rdso-table-header-title">
                    <FaAward style={{ color: '#ff5e14' }} /> RDSO CERTIFICATION MATRIX
                  </h2>
                  <div className="rdso-table-header-subtitle">
                    Official compliance specifications, plant credentials, and testing facility documentation
                  </div>
                </div>
              </div>

              <div className="rdso-table-responsive">
                <table className="rdso-table">
                  <colgroup><col style={{width:'18%'}} /><col style={{width:'38%'}} /><col style={{width:'44%'}} /></colgroup>
                  <thead>
                    <tr>
                      <th style={{ width: '18%' }}>Item</th>
                      <th style={{ width: '38%' }}>Information</th>
                      <th style={{ width: '44%' }}>Information Sub Tab</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sections.map((section, sIndex) => {
                      const showItemCell = Boolean(section.isItemHeader || section.itemRowSpan > 0);
                      const docs = section.documents || [];

                      return (
                        <tr key={section.id || sIndex}>
                          {showItemCell && (
                            <td
                              rowSpan={section.itemRowSpan > 1 ? section.itemRowSpan : undefined}
                              className="rdso-item-cell"
                            >
                              {section.itemTitle}
                            </td>
                          )}

                          <td className="rdso-info-cell" style={{ whiteSpace: 'pre-line' }}>
                            {section.infoTitle}
                          </td>

                          <td className="rdso-subtab-cell">
                            {section.richContent && (
                              <div
                                dangerouslySetInnerHTML={{ __html: section.richContent }}
                              />
                            )}

                            {docs.length > 0 && (
                              <ul className="rdso-subtab-list">
                                {docs.map((doc, dIndex) => {
                                  const docUrl = getMediaUrl(doc.filePath);
                                  return (
                                    <li key={doc.id || dIndex}>
                                      <a
                                        href={docUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="rdso-doc-link"
                                      >
                                        <FaFilePdf style={{ color: '#e53e3e' }} />
                                        <span>{doc.title}</span>
                                        <FaExternalLinkAlt />
                                      </a>
                                      {doc.pageBadge && (
                                        <span className="rdso-doc-tag">{doc.pageBadge}</span>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default RdsoCertification;
